import { useTranslation } from 'next-i18next'
import { BasicEmotion, Emotion } from 'db-tables'

export type EmotionNameProps = {
  emotion?: BasicEmotion | Emotion
  name?: string
  transKey?: 'name' | 'description'
}
export default function EmotionName({ emotion, name, transKey = 'name' }: EmotionNameProps) {
  const { t } = useTranslation()
  if (emotion) {
    return <>{t(`emotions:${emotion.name}.${transKey}`)}</>
  }
  return <>{t(`emotions:${name}.${transKey}`)}</>
}
